import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminLinksNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('link');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
